const API_URL = 'https://ai-spine-api.up.railway.app/api/v1/agents/embed/chat';
const TOKEN = process.env.REACT_APP_AISPINE_TOKEN;

/**
 * Non-streaming chat with AI Spine agent
 * @param {string} message - User message
 * @param {string|null} sessionId - Optional session ID for conversation continuity
 * @returns {Promise<Object>} Response with agent_id, response, session_id, usage, execution_time_ms
 */
export async function chatWithAgent(message, sessionId = null) {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${TOKEN}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      message,
      session_id: sessionId
    })
  });

  if (!response.ok) {
    throw new Error(`AI Spine API error: ${response.status}`);
  }

  return response.json();
}

/**
 * Streaming chat with AI Spine agent (real-time tokens via SSE)
 * @param {string} message - User message
 * @param {string|null} sessionId - Optional session ID for conversation continuity
 * @yields {Object} Event objects with type and content
 */
export async function* streamFromAgent(message, sessionId = null) {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${TOKEN}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      message,
      session_id: sessionId,
      stream: true
    })
  });

  if (!response.ok) {
    throw new Error(`AI Spine API error: ${response.status}`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n\n');
    buffer = lines.pop() || '';

    for (const line of lines) {
      if (line.startsWith('data: ')) {
        try {
          const event = JSON.parse(line.slice(6));
          yield event;
        } catch (e) {
          console.warn('Failed to parse SSE event:', line);
        }
      }
    }
  }
}

const aiSpineApi = { chatWithAgent, streamFromAgent };
export default aiSpineApi;
